import React from "react";
import { NavLink, Link } from "react-router-dom";
import logo from "../../assets/dhanvanti_logo.png";
import Icon from "../../assets/logo.png";


function Header() {
  const [open, setOpen] = React.useState(false);

  return (
    <header className="site-header">
      <div className="container header-inner">
        <nav className={`main-nav ${open ? "open" : ""}`}>
          <ul className="nav-left">
            <li>
              <NavLink to="/" end onClick={() => setOpen(false)}>
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to="/about" onClick={() => setOpen(false)}>About</NavLink>
            </li>
            <li>
              <NavLink to="/leadership" onClick={() => setOpen(false)}>Leadership</NavLink>
            </li>
          </ul>
          <Link to="/" className="brand">
            <img src={Icon} alt="Dhanvanti Icon" style={{height: '40px'}}/>
            <img src={logo} alt="Dhanvanti Logo" style={{ height: "40px" }}/>
          </Link>

          <ul className="nav-right">
            <li>
              <NavLink to="/projects" onClick={() => setOpen(false)}>Our Project</NavLink>
            </li>
            <li>
              <NavLink to="/contact" onClick={() => setOpen(false)}>Contact</NavLink>
            </li>
            <li>
              <NavLink to="/blog" onClick={() => setOpen(false)}>Blog</NavLink>
            </li>
          </ul>

          <button
            className={`nav-toggle ${open ? "open" : ""}`}
            aria-label="Toggle navigation"
            onClick={() => setOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
          </button>
        </nav>
      </div>
    </header>
  );
}

export default Header;

